const topListings = [
  {
    listingUrl: '/trips/2aM5LnVa/',
    headline: 'top-listing--0--headline',
    location: 'top-listing--0--location',
    photoUrl: 'https://img.getmyboat.com/images/1c46186f-03ce-4195-aa08-0fdac3ffeae9/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/QY6Q7ola/',
    headline: 'top-listing--1--headline',
    location: 'top-listing--1--location',
    photoUrl: 'https://img.getmyboat.com/images/fcad5ea7-bfa4-4eda-baf5-20b699dc1214/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/MNxMrOJa/',
    headline: 'top-listing--2--headline',
    location: 'top-listing--2--location',
    photoUrl: 'https://img.getmyboat.com/images/d737abfb-25e1-4b8d-b399-e6aa12af9d9b/-processed.jpg',
    rating: '4.8',
  },
  {
    listingUrl: '/trips/MNxMXAqa/',
    headline: 'top-listing--3--headline',
    location: 'top-listing--3--location',
    photoUrl: 'https://img.getmyboat.com/images/62ba2f18a1be5/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/EYnooPwK/',
    headline: 'top-listing--4--headline',
    location: 'top-listing--4--location',
    photoUrl: 'https://img.getmyboat.com/images/c47b0c9b-8911-4b5e-bca6-56a99ed02e73/-processed.jpg',
    rating: '5.0',
  },
  {
    listingUrl: '/trips/QY674nAK/',
    headline: 'top-listing--5--headline',
    location: 'top-listing--5--location',
    photoUrl: 'https://img.getmyboat.com/images/6022f76bc95e7/-processed.jpg',
    rating: '4.7',
  },
];

export default topListings;
